import React from 'react'
import LeadershipLinks from '../LeadershipLinks'
import '../../../App.css'
import ImageComponent from '../../ImageComponent'

function DaveWolfe() {
    return (
      <div className='bio-pages main-grid-container'>
      <div className='main-grid-item'>
    <LeadershipLinks/>
    </div>
          <div className='main narrow-grid'>
            <div className='bio-img-wrapper'>
              <ImageComponent src={require('../../../img/dave_wolfe_bio_portrait_1000px.jpg')}/>
          {/* <img src={require('../../../img/dave_wolfe_bio_portrait_1000px.jpg')} alt='Dave Wolfe portrait' /> */}
          </div>
            <h1 className='bio-header'>Dave Wolfe</h1>
            {/* <h2 className='bio-subheader'>Pastor of Counseling and Discipleship</h2> */}
            <p> 
            Dave Wolfe is from Southern California, where he came to know Christ at the age of 19. He attended Grace Community Church in Sun Valley California from 1981-2006 and had a 25 year management career at In-n-Out Burger.<br/><br/>
            In 2006 Dave, his wife Tami, and their three daughters moved to Georgetown where he started his own ice vending business and joined Grace Community Fellowship. Dave has led worship, engaged in jail ministry, served as a deacon for many years, and has attended many ACBC counseling training conferences. He was ordained as an elder in October of 2018 and currently leads the Counseling and Discipleship ministry at GCF. His greatest passion is to help others enjoy the abundant blessings of walking in faithful obedience to their great Savior Jesus Christ.<br/><br/>
            Dave and Tami have been married since 1988 and have 3 married daughters and 2 grand daughters.
            </p>
          </div>
          
        </div>
      )
    }

export default DaveWolfe
